import { detect } from 'detect-browser';

const browser = detect();

export const getIsFirefox = () => browser?.name === 'firefox';
